// extracted by mini-css-extract-plugin
export default {"container":"PGid0BD7","staticContainer":"z4jsfg0S"};